import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

interface PlotRecordIDFieldProps {
  value: string;
  error: string | boolean;
  setValue: (value: string) => void;
  setError: (error: string | boolean) => void;
  setChanged: () => void;
  [key: string]: unknown;
}

export default function PlotRecordIDField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  ...rest
}: PlotRecordIDFieldProps): React.JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    setChanged();
    if (/[#^$<>+%!`&*'"|{}?/\\:=@]/.test(newValue)) {
      setError('Name cannot contain #^$<>+%!`&*\'"|{}?/\\:=@');
    } else if (newValue === '') {
      setError('Name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          {...rest}
          label='Record ID'
          id='record_id'
          aria-describedby='record-id-helper-text'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          variant='standard'
          required
        />
        {error ? (
          <FormHelperText id='record-id-helper-text'>
            {String(error)}
          </FormHelperText>
        ) : (
          <FormHelperText id='record-id-helper-text'>
            Enter the unique record ID for this document.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

